<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
                {{ $t('convert_mch') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 시세창 -->
        <div class="price-box">
            <img 
            src="@/assets/price_bg.png"
            class="img-price-box"> 
            <div class="txt-eth-price">{{this.mSymbol}}  {{ $t('market_price') }}</div>
            <div class="txt-eth-value">{{this.mCoinPrice}}</div>
            <div class="txt-eth-unit">MCH</div>
        </div> 
        <!-- 디지파이넥스로고 -->
        <div class="css-img-digifinex"
        v-ripple="{ center: true, class: `teal--text`  }">
            <img 
            src="@/assets/digifinex_logo.png"
            class="img-digifinex-logo"> 
        </div>   
        <div class="css-txt-digifinex">{{ $t('support') }}</div>       
        <!-- 이더로고 -->
        <div class="ether-logo-position">
            <img 
            :src="this.mIconUrl"
            class="img-ether-logo"> 
        </div>    
        <!-- 이더량 -->
        <div class="ether-amount">{{ $satoshiUtil.satoshiToMCH(this.mBalance) }} {{this.mSymbol}}</div>   
        <!-- 라인 -->
        <div class="bottom-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue01-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue02-line"></div>                
        <!-- 한도금액란 -->
        <!--
        <div class="limit-price-position">
            <img 
            src="@/assets/limit_price_bg.png"
            class="img-limit-price"> 
            <!-- 1회 한도 금액 ->
            <div class="one-limie-price">1회 한도 금액</div>
            <!-- / ->
            <div class="one-limie-dash">/</div>
            <!-- 1일 한도 금액 ->
            <div class="oneday-limie-price">1일 한도 금액</div>    
        </div>
        <!-- 한도금액은 다산코인 원화가치 준합니다. ->
        <div class="txt-desc-dasan">한도 금액은 {{this.mCoinName}}의 원화 가치에 준합니다.</div>
        -->
        <!-- 금액입력 -->   
        <div class="txt-input-krw">{{ $t('input_amount_convert') }}</div>
        <!-- 원화금액입력 창 -->
        <div 
        @click.passive="onClickKRW()" 
        class="input-won-position">
            <img 
            src="@/assets/input_won.png"
            class="img-input-won"> 
            <!-- 원화 -->   
            <div class="lbl-input-krw" v-show="this.$langUtil.getCurrency() == 'krw'"> {{ $t('krw_01') }}</div>
            <div class="lbl-input-krw" v-show="this.$langUtil.getCurrency() == 'usd'"> {{ $t('usd_01') }}</div>
            <input class="input-krw-box" type="text" v-model="mKrwVal" placeholder="">
            <!-- 원 -->
            <div class="lbl-input-won" v-show="this.$langUtil.getCurrency() == 'krw'">{{ $t('market_won') }}</div>
            <div class="lbl-input-won" v-show="this.$langUtil.getCurrency() == 'usd'">{{ $t('usd') }}</div>
            <!-- 값 -->
        </div> 
        <!-- 이더리움 입력 창 -->
        <div class="input-ether-position"
        @click.passive="onClickEther()" >
            <img 
            src="@/assets/input_ether_bg.png"
            class="img-input-ether"> 
            <!-- 이더리움 아이콘 -->
            <div class="input-icon-ether">
                <img 
                :src="this.mIconUrl"
                class="img-input-coin-icon"> 
            </div>  
            <div class="txt-coin-name" v-show="$langUtil.getLang() == 'ko'">{{this.mCoinName}} {{this.mSymbol}}</div>
            <div class="txt-coin-name" v-show="$langUtil.getLang() == 'en'">{{this.mCoinNameEn}} {{this.mSymbol}}</div>
            <div class="txt-coin-price" v-show="this.$langUtil.getCurrency() == 'krw'">
                1 {{this.mSymbol}} = {{ this.$currencyUtil.numberWithCommas(this.mEthPriceKRW) }} {{ $t('market_won') }}
            </div>
            <div class="txt-coin-price" v-show="this.$langUtil.getCurrency() == 'usd'">
                1 {{this.mSymbol}} = {{ this.$currencyUtil.numberWithCommas(this.mEthPriceUSD) }} {{ $t('usd') }}
            </div>
            <input class="input-ether-box" type="text" v-model="mEtherVal" placeholder="">
            <div class="input-unit">{{this.mSymbol}}</div>
        </div> 
        <!-- 미콘캐시 입력 창 -->
        <div 
        @click.passive="onClickMch()" 
        class="input-mch-position">
            <img 
            src="@/assets/input_ether_bg.png"
            class="img-input-mch"> 
            <!-- 이더리움 아이콘 -->
            <div class="input-icon-ether">
                <img 
                src="@/assets/mch_logo_icon.png"
                class="img-input-coin-icon-mch"> 
            </div>              
            <div class="txt-coin-name">{{ $t('meconcash') }} MCH</div>
            <div class="txt-coin-price" v-show="this.$langUtil.getCurrency() == 'krw'">
                1 MCH = {{ this.$currencyUtil.numberWithCommas(this.mMCHPriceKRW) }} {{ $t('market_won') }}
            </div>
            <div class="txt-coin-price" v-show="this.$langUtil.getCurrency() == 'usd'">
                1 MCH = {{ this.$currencyUtil.numberWithCommas(this.mMCHPriceUSD) }} {{ $t('usd') }}
            </div>
            <input class="input-ether-box" type="text" v-model="mMCHVal" placeholder="">
            <div class="input-unit">MCH</div>
        </div> 
        <!-- =표시 -->
        <div class="input-equal-position-00">
            <img 
            src="@/assets/equal.png"
            class="img-input-equal"> 
        </div> 
        <!-- =표시 -->
        <div class="input-equal-position-01">
            <img 
            src="@/assets/equal.png"
            class="img-input-equal"> 
        </div>    
        <!-- 보내기 -->
        <div 
        @click.passive="onClickNext()"
        class="btn-confirm-postion"
        v-ripple="{ center: true, class: `teal--text`  }"> 
            <div class="txt-center-confirm"> {{ $t('convert_menu') }}</div>
        </div>
        <!-- 패스워드 입력창 띄우기 -->
        <v-dialog v-model="mDialodPwd" fullscreen hide-overlay transition="dialog-bottom-transition">
            <Password :password="mPasswd" />
        </v-dialog>
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red">
            </v-progress-circular>
        </div>
    </v-app>
</template>
<script>
import axios from 'axios';
import Password from '@/views/Password';
export default {
    created() {
        let payload = this.$route.query.payload;
        let decrypto = this.$cryptoUtil.decrptoMessage(payload);
        let json = JSON.parse(JSON.parse(decrypto));
        this.mMno = json.mno;
        this.mCoinType = json.coin_type;
        this.mSymbol = json.symbol;
        this.mSymbol = this.mSymbol.toUpperCase();
        this.mIconUrl = json.icon_url;
        this.mAddress = json.address;
        this.mCoinName = json.coin_name;
        this.mCoinNameEn = json.coin_name_en;
        this.mLoginKey = json.login_key;
        this.marketPrice();
        this.$EventBus.$on('summit_passwd', (result) => {
            console.log(result);
            this.mDialodPwd = false;
            let sha512Pass = this.$cryptoUtil.sha256Crypto(result);
            this.convertMCH(sha512Pass);
        });
        this.$EventBus.$on('close_passwd', (result) => {
            this.mDialodPwd = false;
        });
    },
    destroyed() {
        console.log("destroyed");
        this.$EventBus.$off('summit_passwd');
        this.$EventBus.$off('close_passwd');
    },
    components: {
        Password,
    },
    data: () => ({
        mMno : "",
        mPasswd : "",
        mCoinType : "",
        mSymbol : "",
        mCoinPrice : "",
        mShowLoading : true,
        mBalance : "",
        mAddress : "",
        mSendAmount : "",
        mSendAddress : "",
        mCoinName : "",
        mCoinNameEn : "",        
        mMCHPriceKRW : "",
        mMCHPriceUSD : "",
        mEthPriceKRW : "",
        mEthPriceUSD : "",
        mCoinRadioKRW : 0,
        mCoinRadioUSD : 0,
        mKrwVal : "",
        mEtherVal : "",
        mMCHVal : "",
        mDialodPwd : false,
        mChargeEther : "",
        mLoginKey : "",
    }),
    watch: {
        mKrwVal : function(val) {
            
            if(this.mChargeEther == 1) return;
            if(this.mChargeEther == 2) return;
            if(this.mChargeEther == -2) return;
            this.mChargeEther = 3;
            if(this.$langUtil.getCurrency() == 'krw') {
                this.mEtherVal = this.$currencyUtil.mathFloor( val / this.mEthPriceKRW );
                this.mMCHVal = this.$currencyUtil.mathFloor( val / this.mMCHPriceKRW );
            } else {
                this.mEtherVal = this.$currencyUtil.mathFloor( val / this.mEthPriceUSD );
                this.mMCHVal = this.$currencyUtil.mathFloor( val / this.mMCHPriceUSD );
            }
    
        },        
        mEtherVal : function(val) {
            console.log("" + this.mChargeEther)
            if(this.mChargeEther == 1) return;
            if(this.mChargeEther == 3) return;
            if(this.mChargeEther == -2) return;
            this.mChargeEther = 2;
            
            if(this.$langUtil.getCurrency() == 'krw') {
                this.mMCHVal = this.$currencyUtil.mathFloor( val * this.mCoinRadioKRW );
                this.mKrwVal = val * this.mEthPriceKRW;
            } else {
                console.log("mEthPriceUSD :" + this.mCoinRadioUSD)
                this.mMCHVal = this.$currencyUtil.mathFloor( val * this.mCoinRadioUSD );
                this.mKrwVal = val * this.mEthPriceUSD;
            }

        },
        mMCHVal : function(val) {
            if(this.mChargeEther == 2) return;
            if(this.mChargeEther == 3) return;
            if(this.mChargeEther == -2) return;
            this.mChargeEther = 1;
            if(this.$langUtil.getCurrency() == 'krw') {
                this.mEtherVal = this.$currencyUtil.mathFloor( val / this.mCoinRadioKRW );
                this.mKrwVal = val * this.mMCHPriceKRW;
            } else {
                this.mEtherVal = this.$currencyUtil.mathFloor( val / this.mCoinRadioUSD );
                this.mKrwVal = val * this.mMCHPriceUSD;
            }
        },
    },
    methods : {
        onClickBack : function() {
            this.$router.go(-1);
        },
        marketPrice : function() {
            let payload = {};
            payload.cmd = "get-market-price";
            payload.mno = this.mMno;
            payload.coin_type = String(this.mCoinType);
            
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                this.mShowLoading = false;
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
                if(serverResponse.result == "1") { // 성공
                    this.mEthPriceKRW = serverResponse.coin_price;
                    this.mEthPriceUSD = serverResponse.coin_price_usd;
                    this.mMCHPriceKRW = serverResponse.mch_price;
                    this.mMCHPriceUSD = serverResponse.mch_price_usd;
                    this.mCoinPrice = this.$currencyUtil.numberWithCommas( this.$currencyUtil.mathFloor( (Number(this.mEthPriceKRW) / Number(this.mMCHPriceKRW) ) ) );
                    this.mCoinRadioKRW = Number(this.mEthPriceKRW) / Number(this.mMCHPriceKRW);
                    this.mCoinRadioUSD = Number(this.mEthPriceUSD) / Number(this.mMCHPriceUSD);
                } else if(serverResponse.result == "2") { // 기존사용자존재
                
                } else if(serverResponse.result == "0") { // 오류
                    
                }
                this.getBalance();
            })
            .catch( ()=>{} );
        },
        onClickNext : function() {
            if(this.mMCHVal.length == 0 || this.mEtherVal.length == 0 || this.mMCHVal == "0" || this.mEtherVal == "0") {
                alert(this.$t('input_value'))
                return;
            }
            let etherSatoshi = this.$satoshiUtil.mchToSatosi(this.mEtherVal);
            if(Number(this.mBalance) < Number(etherSatoshi)) {
                alert(this.$t('no_balance'));  
                return;
            }
            this.mDialodPwd = true;
            //this.convertMCH();
        },
        getBalance : function() {
            let payload = {};
            payload.cmd = "get-balance";
            payload.mno = this.mMno;
            payload.coin_type = this.mCoinType;
            
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log("getBalance : " + JSON.stringify(response) );
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
                console.log("getBalance : " +  JSON.stringify(serverResponse) );
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    this.mBalance = serverResponse.balance;
                } else if(serverResponse.result == "2") { // 기존사용자존재
                
                } else if(serverResponse.result == "0") { // 오류
                    
                }
            })
            .catch( ()=>{} );
        },  
        onClickEther : function() {
            console.log("onClickEther")
            this.mChargeEther = -2;
            this.mEtherVal = "";
            this.mKrwVal = "";
            this.mMCHVal = "";
            setTimeout(function () {
                console.log("setTimeout")
                this.mChargeEther = -1; 
            }.bind(this), 100);
        },
        onClickMch : function() {
            console.log("onClickMch")
            this.mChargeEther = -2;
            this.mMCHVal = "";
            this.mKrwVal = "";
            this.mEtherVal = "";
            setTimeout(function () {
                console.log("setTimeout")
                this.mChargeEther = -1; 
            }.bind(this), 100);
        },
        onClickKRW : function() {
            console.log("onClickKRW")
            this.mChargeEther = -2;  
            this.mKrwVal = "";
            this.mEtherVal = "";
            this.mMCHVal = "";
            setTimeout(function () {
                console.log("setTimeout")
                this.mChargeEther = -1; 
            }.bind(this), 100); 
        },
        convertMCH(shaPass) {
            let etherSatoshi = this.$satoshiUtil.mchToSatosi(this.mEtherVal);
            if(Number(this.balance) < Number(etherSatoshi)) {
                alert(this.$t('no_balance'));  
                return;
            }
            let payload = {};
            payload.cmd = "coin-to-mch";
            payload.mno = this.mMno;
            payload.coin_type = this.mCoinType;
            payload.amount = etherSatoshi;
            payload.amount_mch = this.$satoshiUtil.mchToSatosi(this.mMCHVal);
            payload.passwd = shaPass;
            payload.login_key = this.mLoginKey;
            console.log("" + JSON.stringify(payload) );
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                 let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    this.$router.go(-1);
                } else if(serverResponse.result == "2") { // 존재하지 않는 지갑
                    alert(this.$t('no_wallet'))
                } else if(serverResponse.result == "3") { // 사용자의 보유 코인 부족
                    alert(this.$t('no_user_coin'))
                } else if(serverResponse.result == "4") { // amount 값 오류
                    alert(this.$t('error_amount_value'))  
                } else if(serverResponse.result == "5") { // 한번에 전환할 수 있는 최대 수량 초과
                    alert(this.$t('large_amount'))
                } else if(serverResponse.result == "6") { // 마스터지갑의 보유 MCH 부족
                    alert(this.$t('master_no_lack'))
                } else if(serverResponse.result == "7") { // 시세오차가 크므로 다시 전환 처리요청
                    alert(this.$t('market_price_radio_error')) 
                } else if(serverResponse.result == "8") { // 비밀번호불일치
                    alert(this.$t('wrong_password_00')) 
                } else if(serverResponse.result == "9") { // 로그인키 불일치
                    alert(this.$t('wrong_login_info_00') ) 
                } else { // 오류
                    alert(this.$t('error') );
                } 
            })
            .catch( ()=>{} );
        }
    }
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title-logo {
    position: absolute;
    top: 43%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-title-logo {
    height: 5.925926vw;
    width: 37.407vw;
}
.price-box {
    position: absolute;
    top: 15.37vw; 
    left: 5.6vw;
}
.img-price-box {
    height: 8.148vw;
    width: 88.9vw; 
}
.txt-eth-price {
    position: absolute;
    top: 40%; 
    left: 5.5vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-value {
    position: absolute;
    top: 40%; 
    right: 18vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-unit {
    position: absolute;
    top: 40%; 
    right: 6.2vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.ether-logo-position {
    position: absolute;
    top: 28.148vw; 
    left: 47vw;    
}
.img-ether-logo {
    width: auto;
    height: 8.333vw;     
}
.ether-amount {
    position: absolute;
    top: 37.96296vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    font-family: NanumBarunGothicOTF;
    font-size: 5.092593vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;        
}
.btn-receive {
    position: absolute;
    top: 47.7777vw; 
    left: 25.6vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-send {
    position: absolute;
    top: 47.7777vw; 
    left: 43.7vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-convert {
    position: absolute;
    top: 47.7777vw; 
    left: 61.9vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.img-center-icon {
    position: absolute;
    top: 50%; 
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);       
}
.txt-receive-send {
    position: absolute;
    top: 110%; 
    left: 0px;
    width: 100%;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;   
}
.bottom-line {
    position: absolute;
    top: 59.25vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.bottom-blue01-line {
    position: absolute;
    top: 59.25vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.bottom-blue02-line {
    position: absolute;
    top: 60.25vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.txt-history {
    position: absolute;
    top: 74.81481vw; 
    left: 5.8vw;  
    width: 62px;
    height: 20px;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.img-period {
    width: 100%;
    height: 7.777vw;
}
.input-period {
    position: absolute;
    top: 81.85185vw; 
    left: 5.6vw; 
    right: 5.6vw;
}
.qrcode-box {
    position: absolute;
    top: 57.407vw; 
    left: 26vw; 
    width: 52.22vw;
    height: 52.22vw;     
    background-color: gray;  
}
.txt-qrcdoe {
    position: absolute;
    top: 111.11vw; 
    left: 0vw;
    width: 100vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center; 
    color:#231815;
    pointer-events: none; 
}
.txt-eth-address {
    position: absolute;
    top: 123.37vw; 
    left: 6.2vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.txt-address-bg {
    position: absolute;
    top: 127.963vw; 
    left: 5.6vw; 
    pointer-events: none; 
}
.img-address-bg {
    width: 88.9vw;
    height: 7.407407vw;
}
.btn-copy-address {
    position: absolute;
    top: 143.5185vw; 
    left: 43.148vw;  
}
.img-copy-address {
    width: 13.7037vw;
    height: 13.7037vw;
}
.txt-copy-address {
    position: absolute;
    top: 159.6296vw; 
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e; 
    transform: translate(-50%, 0%);  
    pointer-events: none;         
}
.amount-input-line {
    position: absolute;
    top: 62.2222vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.address-input-line {
    position: absolute;
    top: 76.111vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.txt-amount-unit {
    position: absolute;
    top: 56.2963vw; 
    right: 10.6vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 4.166vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #626262;
    pointer-events: none; 
}
.btn-delete-icon {
    position: absolute;
    top: 55vw; 
    right: 20.37vw;  
    width: 5vw;
    height: 5vw;    
}
.btn-paste-postion {
    position: absolute;
    top: 69.25926vw; 
    right: 10.4vw; 
}
.img-paste-postion {
    width: 17.03704vw;
    height: 4.4444vw;    
}
.txt-paste {
    position: absolute;
    top: 32%;  
    left: 0px;  
    width: 100%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;   
    transform: translate(0%, -50%);  
    pointer-events: none;         
}
.btn-qrcode-postion {
    position: absolute;
    top: 77.77778vw; 
    left: 43.1vw;  
}
.img-qrcode-postion {
    width: 13.7037vw;
    height: 13.7037vw;  
}
.txt-qrcode {
    position: absolute;
    top: 91.6666vw; 
    left: 45.6vw;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e;     
    pointer-events: none;    
}
.btn-confirm-postion {
    position: fixed;
    bottom: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 14.35185vw;   
    background-color: #345993;
}
.txt-center-confirm {
    position: absolute;    
    top: 50%;  
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 4.1666vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    transform: translate(-50%, -50%);  
    pointer-events: none; 
}
.amount-box-00 {
    position: absolute;
    top: 52.40741vw; 
    left: 5.6vw;   
}
.amount-box-01 {
    position: absolute;
    top: 62.96296vw; 
    left: 5.6vw;   
}
.amount-box-02 {
    position: absolute;
    top: 73.51852vw; 
    left: 5.6vw;   
}
.amount-box-03 {
    position: absolute;
    top: 88.3333vw; 
    left: 5.6vw;   
}
.img-box {
    width: 88.8888vw;
    height: 7.407407vw; 
}
.img-box-01 {
    width: 88.8888vw;
    height: 11.666vw; 
}
.txt-amount-label {
    position: absolute;
    top: 20%; 
    left: 5.2vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #595757;      
}
.txt-amount-value {
    position: absolute;
    top: 20%; 
    right: 5.2vw;     
    width: 65%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #595757;  
}
.limit-price-position {
    position: absolute;
    top: 45.55vw; 
    left: 5.6vw;  
}
.img-limit-price {
    width: 88.9vw;
    height: 7.4vw; 
}
.one-limie-dash {
    position: absolute;
    top: 17%; 
    left: 50%;  
    width: 8px;
    height: 20px;
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #595757;
}
.one-limie-price {
    position: absolute;
    top: 17%; 
    left: 5%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #595757;
}
.oneday-limie-price {
    position: absolute;
    top: 17%; 
    left: 60%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #595757;
}
.txt-input-krw {
    position: absolute;
    top: 62.77vw; 
    left: 5.3vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000; 
}
.txt-desc-dasan {
    position: absolute;
    top: 53.703vw; 
    left: 0vw; 
    width: 100vw;
    text-align: center; 
    font-family: NanumBarunGothicOTF;
    font-size: 2.3148vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #595757;
}
.input-won-position {
    position: absolute;
    top: 71.2963vw; 
    left: 5.6vw; 
}
.img-input-won {
    width: 88.9vw;
    height: 9.6vw; 
}
.lbl-input-krw {
    position: absolute;
    top: 22%; 
    left: 8.2vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #353535;
}
.lbl-input-won {
    position: absolute;
    top: 22%; 
    right: 5.5vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #353535;
}
.input-ether-position {
    position: absolute;
    top: 91.48vw; 
    left: 5.6vw; 
}
.img-input-ether {
    width: 88.9vw;
    height: 16.48vw; 
}
.input-mch-position {
    position: absolute;
    top: 118.5185vw; 
    left: 5.6vw; 
}
.img-input-mch {
    width: 88.9vw;
    height: 16.48vw; 
}
.input-equal-position-00 {
    position: absolute;
    top: 83vw; 
    left: 46.1vw; 
}
.input-equal-position-01 {
    position: absolute;
    top: 111vw; 
    left: 46.1vw; 
}
.img-input-equal {
    width: auto;
    height: 2.407407vw; 
}
.input-icon-ether {
    position: absolute;
    top: 0vw; 
    left: 0vw; 
}
.img-input-coin-icon {
    position: absolute;
    top: 1vw; 
    left: 4vw;     
    width: auto;
    height: 5vw; 
}
.img-input-coin-icon-mch {
    position: absolute;
    top: 1.5vw; 
    left: 4vw;     
    width: 5vw;
    height: auto; 
}
.txt-coin-name {
    position: absolute;
    top: 1.5vw; 
    left: 11vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #353535;     
}
.txt-coin-price {
    position: absolute;
    top: 1.5vw; 
    right: 5.3vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #353535;
}
.input-krw-box {
    position: absolute;
    top: 2.3vw; 
    right: 14vw; 
    width: 60vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 4vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #353535;
}
.input-ether-box {
   position: absolute;
    bottom: 4vw; 
    right: 14vw; 
    width: 60vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 4vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #353535;
}
.input-unit {
    position: absolute;
    bottom: 4vw; 
    right: 5vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #353535;     
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.css-img-digifinex {
    position: absolute;
    top: 24vw;
    right: 6.5vw; 
}
.css-txt-digifinex {
    position: absolute;
    top: 24.8vw;
    right: 23vw;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #353535;          
}
.img-digifinex-logo {
    width: auto;
    height: 5vw; 
}
*:focus {
    outline: none;
}
</style>